import { section } from '@/glow';
import { AnimateCollectionBanner } from '@/lib/animation';

section('collection-banner', {
  onLoad() {
    this.AnimateCollectionBanner = AnimateCollectionBanner(this.container);
  },

  onUnload() {
    this.AnimateCollectionBanner?.destroy();
  }
});
